export const satisfactionConfirmation = (() => {
    const banner = document.querySelector('.js-satisfaction-confirmation');
    const dismiss = document.querySelector('.js-satisfaction-close');

    const dismissNotice = () => {
        document.body.removeChild(banner);
    }

    const init = () => {
        if (!banner || !dismiss) {
            return;
        }
        dismiss.addEventListener('click', dismissNotice);
    };

    init();
})();
